import { Fragment, ReactNode } from "react";
import { User } from "~/modules/user/store/types";
import { UpdateApiKeyFunction, UpdateApiKeyParams } from "./types";
import { api } from "~/utils/api";
import { ApiKey } from "../../types";

// // // //

interface ChildProps {
    error: boolean;
    loading: boolean;
    updateApiKey: UpdateApiKeyFunction;
}

export function ApiKeyUpdater(props: {
    user: User;
    children: (childProps: ChildProps) => ReactNode;
}) {
    // Fetch items via tRPC
    const updateMutation = api.apiKeys.update.useMutation();

    // Set loading + error state
    const loading = updateMutation.isLoading || false;
    const error = updateMutation.error !== undefined;

    async function updateApiKey(
        updatedApiKey: UpdateApiKeyParams,
    ): Promise<ApiKey | null> {
        return updateMutation.mutateAsync({
            name: updatedApiKey.name,
            archived: updatedApiKey.archived,
            apiKeyID: updatedApiKey.id,
            organizationID: props.user.organization.id,
        });
    }

    return (
        <Fragment>
            {props.children({
                error,
                loading,
                updateApiKey,
            })}
        </Fragment>
    );
}
